import React, { useState, useEffect } from "react";
import './StopwatchComponent.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faTrash,faRedo,faPause } from '@fortawesome/free-solid-svg-icons';

function StopwatchComponent() {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    let interval = null;

    if (isRunning) {
      interval = setInterval(() => {
        setTime(prevTime => prevTime + 10);
      }, 10);
    } else if (!isRunning && time !== 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isRunning, time]);

  useEffect(() => {
    const storedHistory = localStorage.getItem('stopwatchHistory');
    if (storedHistory) {
      setHistory(JSON.parse(storedHistory));
    }
  }, []);

  const handleStartStop = () => {
    setIsRunning(!isRunning);
  };

  const handleReset = () => {
    if (time > 0) {
      const formattedTime = formatTime(time);
      const newHistory = [...history, { time, formattedTime }];
      setHistory(newHistory);
      localStorage.setItem('stopwatchHistory', JSON.stringify(newHistory));
    }
    setTime(0);
    setIsRunning(false);
  };

  const formatTime = (time) => {
    const getMilliseconds = `0${(time % 1000) / 10}`.slice(-2);
    const getSeconds = `0${Math.floor((time / 1000) % 60)}`.slice(-2);
    const getMinutes = `0${Math.floor((time / 60000) % 60)}`.slice(-2);
    const getHours = `0${Math.floor((time / 3600000) % 24)}`.slice(-2);
    return `${getHours}:${getMinutes}:${getSeconds}.${getMilliseconds}`;
  };

  const handleResume = (timeToResume) => {
    setTime(timeToResume);
    setIsRunning(true);
  };

  const handleDelete = (indexToDelete) => {
    const updatedHistory = history.filter((_, index) => index !== indexToDelete);
    setHistory(updatedHistory);
    localStorage.setItem('stopwatchHistory', JSON.stringify(updatedHistory));
  };

  const analogRotation = {
    seconds: ((time / 1000) % 60) * 6,
    minutes: ((time / 60000) % 60) * 6,
    hours: ((time / 3600000) % 12) * 30
  };

  return (
    <div className="stopwatch-container">
      <div className="analog-stopwatch">
        <div className="clock-face">
          <div className="central-circle"></div>
          <div
            className="clock-hand hour-hand"
            style={{ transform: `rotate(${analogRotation.hours}deg)` }}
          ></div>
          <div
            className="clock-hand minute-hand"
            style={{ transform: `rotate(${analogRotation.minutes}deg)` }}
          ></div>
          <div
            className="clock-hand second-hand"
            style={{ transform: `rotate(${analogRotation.seconds}deg)` }}
          ></div>
        </div>
      </div>

      <div className="digital-stopwatch">
        <div className="time-display">{formatTime(time)}</div>
        <div className="controls">
          <button onClick={handleStartStop}>
            <FontAwesomeIcon icon={isRunning ? faPause : faPlay} />
          </button>
          <button onClick={handleReset}>
            <FontAwesomeIcon icon={faRedo} />
          </button>
        </div>
      </div>

      <div className="history-container">
        {history.map((entry, index) => (
          <div key={index} className="history-card">
            <div className="history-time">{entry.formattedTime}</div>
            <div className="card-buttons">
              <button
                className="resume-button"
                onClick={() => handleResume(entry.time)}
              >
                <FontAwesomeIcon icon={faPlay} />
              </button>
              <button
                className="delete-button"
                onClick={() => handleDelete(index)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StopwatchComponent;
